exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".selfie-capture-container .selfie-capture{border:1px dashed #555;border-radius:3px;padding:14px 10px 5px 10px;display:flex;justify-content:space-between;color:gray;font-weight:700;font-size:15px;margin:0 50px;cursor:pointer}\n", ""]);

